import loadingGif                               from '../../assets/gif-loading.gif';
import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import '../../styles/Table.css';

export default function PxoHiddenRowsModal ({

    isModalOpen,
    closeModal,
    content,
    handleChangeCheckBox,   
    handleSubmit,           
    isLoading               

}) {

    return (
            
        <Dialog 
            open={isModalOpen} 
            onClose={closeModal} 
            className="relative z-[100]"
        >

            <DialogBackdrop 
                transition 
                className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
        
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                
                <div className=" flex min-h-full items-end justify-center p-1 text-center sm:items-center sm:p-0">
                    
                    <DialogPanel 
                        transition 
                        className="w-[505px] min-h-[505px]relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >   
                        
                        <div className="app-container">
                            
                            {/* #region header */}   
                            <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                            
                                <h2 className="text-white text-[1rem] leading-7 font-semibold">PxO: Linhas ocultas</h2>
                                <button onClick={closeModal} className="text-[1.2rem] text-white hover:text-gray-200 pr-2">×</button>
                            
                            </header>

                            {/* #endregion */}
                            <div className="px-4 pb-4 pt-2 sm:pb-4 flex flex-col gap-[10px] max-h-[40vh] overflow-y-auto">
                                
                                {content && 
                                    <table className='table-pattern-sistem borda-cinza'>

                                        <thead className='bg-neutro'>
                                            <tr>
                                                <th>#</th>
                                                <th>terminal</th>
                                                <th>produto</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                            
                                        <tbody>
                                            { content.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.ownerTerminal.name}</td>
                                                    <td>{item.ownerProduct.name}</td>
                                                    <td>
                                                        <div className="flex items-center">
                                                            <input 
                                                                type="checkbox" 
                                                                checked={item.isHidden || false}
                                                                onChange={() => {handleChangeCheckBox(item.id)}}
                                                                className="w-4 h-4 !m-auto !block ![appearance:auto] text-blue-600 bg-gray-100 border-gray-300 rounded-sm"
                                                            />
                                                
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
        
                                    </table>
                                }

                                            
                            </div>

                            {/* #region footer */}            
                            <footer className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                
                                <button 
                                    type="submit" 
                                    onClick={()=>{handleSubmit()}} 
                                    className="btn btn-azul-prof sm:ml-3 w-[100%] text-[1.125rem]"
                                >
                                    {!isLoading? 
                                        'Salvar' :
                                        <img src={loadingGif} className="w-4 h-4 m-auto"/>
                                    }

                                </button>

                            </footer>
                            {/* #endregion */}
                                        
                        </div>
                        
                    </DialogPanel>

                </div>

            </div>

        </Dialog>
    )

}